import { useContext } from 'react';
import { AuthDecisionContext } from '../Routes';

/**
 * Reads the subscription read-only flag resolved by AuthRouter.
 *
 * A company is soft-locked (read-only) when its Stripe subscription_status
 * is `past_due` or `unpaid` — the app still renders and all historical data
 * stays visible, but create/edit affordances should be disabled. Admins
 * recover by updating payment, which flips the flag back automatically.
 *
 * Returns `{ isReadOnly, status }`. Returns `false` / `null` outside an
 * AuthDecisionContext provider (e.g. pre-resolution or logged-out routes).
 */
export default function useSubscriptionReadOnly() {
  const ctx = useContext(AuthDecisionContext);
  return {
    isReadOnly: !!ctx?.subscriptionReadOnly,
    status: ctx?.subscriptionStatus ?? null,
  };
}
